// extracted by mini-css-extract-plugin
module.exports = {"Close":"CloseButton_Close__2w7Ih"};